import { useEffect, useState } from 'react';
import { getTenantId } from '../api/tenantHeader.ts';
import apiService from '../services/apiService.ts';

export const useLocations = (tenantId: string) => {
  const effectiveTenantId = tenantId || String(getTenantId() || '');
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    if (!effectiveTenantId) return;
    setLoading(true);
    try {
      const data = await apiService.getLocations(effectiveTenantId);
      setRows(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [effectiveTenantId]);

  return { rows, loading, reload: fetchData };
};
